module.exports = __webpack_public_path__ + "static/media/institution.59d44f88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/institution.svg
// module id = 112
// module chunks = 0